//#region src/constant.ts
var DEFAULT_SCOPE = "default";
var DEFAULT_REMOTE_TYPE = "global";
//#endregion
exports.DEFAULT_REMOTE_TYPE = DEFAULT_REMOTE_TYPE;
exports.DEFAULT_SCOPE = DEFAULT_SCOPE; //# sourceMappingURL=constant.cjs.map
